<p>payment-promo works!</p>
